import React, { useState, useEffect } from "react";

const CommonQuestions = () => {
  const [showMore, setShowMore] = useState(false);

  const showMoreHandler = () => {
    setShowMore((prev) => !prev);
  };
  return (
    <div
      style={{ direction: "rtl" }}
      className="border-t-4  mb-1 border-transparent  bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511]"
    >
      <div className="py-1  bg-white  ">
        <div className="w-[80%] mx-auto py-10  grid grid-cols-1 ">
          <div
            className="mb-3 font-bold text-2xl 
                 screen1000:text-xl
                 screen800:text-base
                 screen600:text-sm"
          >
            سوالات متداول :
          </div>

          <div
            className="text-lg text-[#4c4c4c]   text-justify 
                screen1000:text-base
               screen800:text-sm
               screen600:text-xs"
          >
            <ol
              style={{
                listStyleType: "number",
                direction: "rtl",
                listStylePosition: "inside",
              }}
              className={`overflow-hidden 
               ${!showMore && `line-clamp-5 overflow-visible leading-loose `}`}
            >
              <li>
                <span className="font-bold ml-2">
                  مراحل ثبت نام در سامانه بام بانک ملی چگونه است ؟
                </span>
                جهت ثبت نام در سامانه بام، شخص باید در بانک ملی دارای حساب فعال
                باشد. همچنین شماره همراه وی باید در سامانه پیام کوتاه بانک ملی
                ثبت شده باشد. سپس با وارد شدن در سایت www.baam.bmi.ir نسبت به
                تکمیل اطلاعات اقدام و در پایان شماره حساب ارزی به نام شما صادر
                میگردد.
              </li>
              <li className="my-5">
                <span className="font-bold ml-2">
                  آیا شما ارز دولتی می فروشید؟
                </span>
                در حال حاضر ارزی تحت عنوان ارز دولتی وجود ندارد. بلکه فروش ارز
                با نرخ حاشیه بازار (سامانه جامع ارزی ) و به صورت رسمی می باشد.
              </li>
              <li>
                <span className="font-bold ml-2">
                  نرخ خرید فروش شما با بازار آزاد چقدر اختلاف دارد ؟
                </span>
                نرخ خرید و فروش در صرافی دولت بر اساس نرخ سامانه جامع ارزی ایران
                و نرخ معاملات در سامانه سنا و نیما می باشد.
              </li>
              <li className="my-5">
                <span className="font-bold ml-2">
                  آیا بجای فرد حقیقی دیگری انجام معامله صورت می پذیرد؟
                </span>
                خیر، حضور شخص حقیقی برای معامله الزامی است.
              </li>
              <li className="leading-loose">
                <span className="font-bold ml-2">
                  مقدار ارز و مدارک مورد نیاز برای معامله چیست ؟
                </span>
                در حال حاضر بر اساس شیوه نامه های ابلاغی از سوی بانک مرکزی
                جمهوری اسلامی ایران هر فرد حقیقی می تواند در سال تا سقف مقرر به
                یورو یا معادل دلاری آن بصورت اسکناس و پس از ارائه مدارک ذیل با
                عنوان ارز مسافرتی خریداری نمایند.
                <br />
                • اصل کارت ملی ( در صورت داشتن کارت ملی قدیمی ارائه کارت ملی به
                همراه شناسنامه و رس ید ممهور ثبت احوال مبنی بر انجام مراحل تعویض
                کارت ملی قدیمی)
                <br />
                • کارت بانکی عضو شبکه شتاب به نام فرد خریدار بر ای خرید و شماره
                شبا به نام فرد فروشنده برای فروش
                <br />
                • شماره تلفن همراه (سیم کارت) به نام فرد متقاضی
                <br />
                • تکمیل فرم های مربوطه و امض ای آن ها در حضور متصدی صرافی
                <br />
                بدیهی است پس از بررسی های لازم از جمله احراز اصالت و اعتبار
                مدارک ارائه شده، فروش ارز انجام خواهد شد و در صورت نقص مدارک یا
                عدم اعتبار هر یک از آن ها صرافی از فروش ارز معذور می باشد.
              </li>
              <li className="my-5">
                <span className="font-bold ml-2">
                  آیا صرافی دولت ارز دیجیتال (بیت کوین، اتر و...) خریداری می
                  کند؟
                </span>
                خیر، با توجه به اینکه حسب مقررات جاری در حال حاضر هیچ یک از
                صرافی ها، مجاز به فعالیت در فضای مجازی نیستند، لذا صرافی دولت
                فعلاً در حوزه ارزهای دیجیتال فعالیتی ندارد.
              </li>
              <li>
                <span className="font-bold ml-2">
                  ورود و خروج ارز توسط هر مسافر به صورت اسکناس تا چه میزان مجاز
                  است ؟
                </span>
                ورود ارز توسط هر مسافر تا سقف ده هزار یورو یا معادل آن به سایر
                ارزها و خروج ارز توسط هر مسافر تا سقف پنج هزار یورو یا معادل آن
                به سایر ارزها از مرزهای هوایی، تا سقف دو هزار یورو یا معادل آن
                به سایر ارزها از طریق مرزهای زمینی، ریلی و دریایی مجاز است.
              </li>
              <li className="my-5">
                <span className="font-bold ml-2">
                  ورود ارز به صورت اسکناس برای بیش از سقف تعیین شده چگونه است ؟
                </span>
                برای ورود ارز/اسناد بانکی و اوراق بهادار بینام مجموعاً به مبلغ
                بیش از سقف تعیین شده، مسافر میبایست در مبادی ورودی نسبت به اظهار
                ارز/اسناد بانکی و اوراق بهادار بینام همراه خود (به صورت کتبی یا
                شفاهی) به گمرک جمهوری اسلامی ایران اقدام و اطلاعات مورد نیاز را
                به صورت سیستمی از طریق درگاه گمرک ج.ا.ا ثبت نماید. ضمناً مسافر
                میتواند قبل از ورود به کشور از طریق درگاه مزبور، ارز/اسناد بانکی
                و اوراق بهادار بینام همراه خود را به صورت سیستمی اظهار نماید.
              </li>
              <li className="my-5">
                <span className="font-bold ml-2">
                  آیا خرید و فروش ارز در صرافی مشمول مالیات می شود؟
                </span>
                تمامی اطلاعات مشتری که در سیستم سنا ثبت می گردد قابل دسترسی برای
                سازمان امور مالیاتی می باشد. لطفا در این زمینه با مشاور مالیاتی
                خود مشورت نمائید.
              </li>
              <li>
                <span className="font-bold ml-2">
                  نرخ حواله نیمائی چقدر است ؟
                </span>
                نرخ حواله نیمائی بر اساس شرایط بازار تغییر کرده و بایستی هماهنگی
                با کارشناسان صرافی ضمن اعلام گروه کالائی صورت پذیرد . کارمزد
                حواله ها چگونه محاسبه می شود ؟ کارمزد انجام حواله جات براساس نوع
                حواله و نوع ارز درخواستی مشخص می گردد.
              </li>
            </ol>
            <div
              className={`bg-[#5f5f5f] text-white  px-4 py-0.5 w-fit float-left mt-4 font-bold rounded-full cursor-pointer
                  ${showMore && "mt-4"} `}
              onClick={showMoreHandler}
            >
              {showMore ? "کمتر" : "بیشتر"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonQuestions;
